/**
 * Utility functions for avatar management
 */

import { IAvatar } from '../types';

// Array of avatar filenames in the assets folder
export const AVATAR_FILENAMES = [
  'images/avatar1.png',
  'images/avatar2.png',
  'images/avatar3.png',
  'images/avatar4.png',
  'images/avatar5.png',
  'images/avatar6.png',
  'images/avatar7.png',
  'images/avatar8.png',
  'images/avatar9.png',
  'images/avatar10.png',
  'images/avatar11.png',
  'images/avatar12.png',
  'images/avatar13.png',
  'images/avatar14.png',
  'images/avatar15.png',
  'images/avatar16.png',
  'images/avatar17.png',
  'images/avatar18.png',
  'images/avatar19.png',
  'images/avatar20.png',
  'images/avatar21.png',
  'images/avatar22.png',
];

/**
 * Returns a random avatar image filename from the available assets
 */
export const getRandomAvatarImage = (): string => {
  const randomIndex = Math.floor(Math.random() * AVATAR_FILENAMES.length);
  return AVATAR_FILENAMES[randomIndex];
};

/**
 * Creates a simple avatar with just an image URL
 * All other properties are set to defaults since only the image is used
 */
export const createAvatarWithImage = (imageUrl: string): IAvatar => {
  return {
    hairStyle: 'short' as any, // Not used when imageUrl is present
    hairColor: '#8B4513',      // Not used when imageUrl is present
    skinColor: 'medium' as any, // Not used when imageUrl is present
    eyeColor: 'brown' as any,   // Not used when imageUrl is present
    accessory: 'none' as any,   // Not used when imageUrl is present
    isSmiling: true,            // Not used when imageUrl is present
    imageUrl,
  };
};

/**
 * Creates two avatars with different images
 */
export const createDifferentAvatars = (): [IAvatar, IAvatar] => {
  // Ensure we have at least 2 different images
  if (AVATAR_FILENAMES.length < 2) {
    throw new Error('Need at least 2 avatar images to create different avatars');
  }

  // Get two different random images
  const image1 = getRandomAvatarImage();
  let image2: string;
  
  do {
    image2 = getRandomAvatarImage();
  } while (image2 === image1);

  return [
    createAvatarWithImage(image1),
    createAvatarWithImage(image2),
  ];
};
